var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"relative w-full h-screen absolute inset-0 flex"},[_c('canvas',{ref:"canvasRef",staticClass:"absolute inset-0",attrs:{"width":_setup.dimensions.width,"height":_setup.dimensions.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }